import OfferGenerationWizardContainer from './OfferGenerationWizardContainer';

export default OfferGenerationWizardContainer;
